<template>
  <v-card flat dense>
    <v-card-title>
      {{ $t('ITEM.VIEW') }} {{ $t('LINKED_ADDRESSES.ITEM') }}
      <v-spacer />
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <errors :errors="errorMessages" />
      <v-form v-model="valid">
        <address-linked-form
          v-model="address"
          :person-id="personId"
          :errors="errors"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" depressed @click="remove">
        {{ $t('BUTTON.DELETE') }}
      </v-btn>
      <v-spacer />
      <v-btn class="mr-2" outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-btn depressed color="primary" :disabled="!valid" @click="update">
        {{ $t('BUTTON.UPDATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import AddressLinkedForm from '@/modules/addresses/components/forms/AddressLinkedForm';

export default {
  name: 'ViewLinkedAddress',

  components: {
    AddressLinkedForm,
    Errors: () => import('@/modules/_global/_components/Errors')
  },

  mixins: [errors],

  props: {
    personId: {
      type: Number,
      required: true
    },
    addressId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: false,
      errorMessages: [],
      address: {}
    };
  },

  mounted() {
    this.getLinkedAddress({
      personId: this.personId,
      addressId: this.addressId
    }).then(({ data }) => {
      this.address = data.data;
    });
  },

  methods: {
    ...mapActions('person', [
      'updateLinkedAddress',
      'getLinkedAddress',
      'deleteLinkedAddress'
    ]),

    cancel() {
      this.$emit('cancel');
    },

    update() {
      this.updateLinkedAddress({
        address: this.address,
        addressId: this.address.id,
        personId: this.personId
      })
        .then(({ data }) => {
          this.$emit('updated', data.data);
        })
        .catch(this.errorHandler);
    },

    remove() {
      this.deleteLinkedAddress({
        personId: this.personId,
        addressId: this.addressId
      })
        .then(({ data }) => {
          this.$emit('removed', data);
        })
        .catch(this.errorHandler);
    },

    errorHandler({ response }) {
      this.handleErrorsByResponse(response);
      this.errorMessages = [this.extractErrorMessage(response)];
    },

    extractErrorMessage(response = {}) {
      return response.data && response.data.message;
    }
  }
};
</script>
